
const Bell = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g clipPath="url(#clip0_8186_31838)">
        <path
          d="M1.75786 3.57895C1.44484 3.77051 1.03581 3.67229 0.843901 3.35949C0.651759 3.04632 0.749997 2.63667 1.06328 2.4447L4.41712 0.389571C4.73114 0.197151 5.14171 0.296043 5.33367 0.610338C5.52533 0.924121 5.42651 1.33385 5.1129 1.52577L1.75786 3.57895ZM15.9161 11.1611C15.6031 10.9678 15.1926 11.0649 14.9993 11.378L12.9489 14.6999C12.7558 15.0128 12.8527 15.423 13.1655 15.6164C13.4786 15.81 13.8894 15.7129 14.0828 15.3996L16.1329 12.0776C16.3261 11.7647 16.229 11.3544 15.9161 11.1611ZM14.4493 9.73302L11.1666 15.055C11.017 15.3084 10.8111 15.524 10.5649 15.6852C10.3187 15.8463 10.0387 15.9487 9.74661 15.9843C9.66255 15.9945 9.57795 15.9997 9.49327 15.9997C9.23894 15.9999 8.9871 15.9497 8.75229 15.8519C8.51748 15.7542 8.30437 15.6109 8.12527 15.4303L7.48327 14.7883C6.87333 15.2153 6.13246 15.4136 5.39079 15.3486C4.64913 15.2835 3.9541 14.9592 3.42777 14.4327C2.90144 13.9061 2.57747 13.2109 2.51276 12.4692C2.44806 11.7275 2.64675 10.9868 3.07394 10.377L1.06861 8.37102C0.865184 8.16759 0.709533 7.92148 0.612919 7.6505C0.516306 7.37952 0.481147 7.09045 0.509988 6.80422C0.538828 6.51798 0.630947 6.24173 0.779676 5.99547C0.928406 5.74922 1.13002 5.53911 1.36994 5.38035L6.54461 2.21368C7.5229 1.58666 8.67267 1.28101 9.83318 1.33946C10.9937 1.39791 12.1069 1.81754 13.0173 2.53968L13.8073 1.74968C14.0676 1.48937 14.4896 1.48937 14.7499 1.74968C15.0103 2.00999 15.0103 2.43204 14.7499 2.69235L13.9546 3.48768C14.6461 4.36275 15.0623 5.42341 15.1503 6.53523C15.2384 7.64706 14.9944 8.76 14.4493 9.73302ZM6.50661 13.8117L4.04527 11.3483C3.8622 11.6929 3.79517 12.0873 3.85414 12.4729C3.91311 12.8586 4.09494 13.2149 4.37261 13.489C4.65236 13.755 5.00711 13.9286 5.3888 13.9864C5.7705 14.0441 6.16071 13.9831 6.50661 13.8117ZM12.5866 3.93302C11.8988 3.23989 10.9941 2.80366 10.0235 2.69713C9.05283 2.5906 8.07502 2.82023 7.25327 3.34768L2.08527 6.50502C2.01457 6.55442 1.95562 6.61881 1.91264 6.69359C1.86966 6.76838 1.8437 6.85172 1.83661 6.93768C1.82698 7.02734 1.83769 7.11801 1.86793 7.20296C1.89817 7.2879 1.94716 7.36494 2.01127 7.42835L9.06861 14.4877C9.13337 14.5543 9.21294 14.6048 9.30086 14.6349C9.38879 14.665 9.48258 14.674 9.57461 14.661C9.66672 14.6499 9.755 14.6175 9.8325 14.5665C9.91001 14.5155 9.97462 14.4472 10.0213 14.367L13.3013 9.05168C13.7536 8.23646 13.9285 7.29623 13.7996 6.37288C13.6707 5.44953 13.2449 4.59317 12.5866 3.93302Z"
          fill="url(#paint0_linear_8186_31838)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_8186_31838"
          x1="8.48927"
          y1="0.0410156"
          x2="8.48927"
          y2="15.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF394A" />
          <stop offset="1" stopColor="#FF959E" />
        </linearGradient>
        <clipPath id="clip0_8186_31838">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Bell;
